<template>
  <v-container>
    <!-- <v-switch v-model="itemDatabase" :label="$t('entities.stageItem.itemDatabase')"></v-switch> -->
    <v-form ref="form" v-model="valid">
      <auto-complete-entity
        ref="itemId"
        v-model="value.itemId"
        entityApi="item"
        :itemPreSelected="selectedItem"
        itemText="description"
        itemValue="id"
        :label="$t('entities.stageItem.props.itemId')"
        :clearable="true"
        :rules="$isRequiredRule"
      />

      <auto-complete-entity
        ref="unitId"
        v-model="value.unitId"
        entityApi="unit"
        fieldApi="description"
        itemText="description"
        itemValue="id"
        :itemPreSelected="selectedUnit"
        :label="$t('entities.stageItem.props.unitId')"
        :clearable="true"
        :rules="value.itemId ? [] : $isRequiredRule"
      />
      <v-text-field
        v-if="selectedItem && selectedItem.type == 'Parameter'"
        :label="$t('entities.stageItem.props.qtMin')"
        type="number"
        v-model="value.qtMin"
      ></v-text-field>
      <v-text-field
        v-if="selectedItem && selectedItem.type == 'Parameter'"
        :label="$t('entities.stageItem.props.qtMax')"
        type="number"
        v-model="value.qtMax"
      ></v-text-field>
      <v-text-field
        v-if="selectedItem && selectedItem.type == 'Parameter'"
        :label="$t('entities.stageItem.props.qtIdeal')"
        v-model="value.qtIdeal"
        type="number"
        :rules="
          selectedItem && selectedItem.type == 'Parameter'
            ? $isRequiredRule
            : []
        "
      ></v-text-field>
      <v-text-field
        :label="$t('entities.stageItem.props.qt')"
        type="number"
        v-model="value.qt"
        :rules="$isRequiredRule"
      ></v-text-field>

      <v-text-field
        :label="$t('entities.stageItem.props.itemDescription')"
        v-model="value.itemDescription"
        clearable
      ></v-text-field>
    </v-form>
  </v-container>
</template>

<script>
// import itemPage from "@/views/ItemPage";
export default {
  components: {},
  props: {
    value: {
      default() {
        return { qt: 0, itemId: null };
      }
    }
  },
  data() {
    return {
      itemDatabase: true,
      loadingItem: false,
      valid: false,
      selectedItem: null,
      selectedUnit: null,
      units: []
    };
  },
  watch: {
    async "value.itemId"() {
      this.selectedItem = null;
      this.selectedUnit = null;
      await this.getUnits();
      await this.getUnit();
      await this.setItem();
     this.setUnitId();
      this.$forceUpdate();
    },

  },
  methods: {
    setUnitId(){
     if(this.selectedItem && this.selectedItem.unitId)
      this.value.unitId = this.selectedItem.unitId
    },
    isValid() {
      let formValid = this.$refs.form.validate();
      let itemIdValid = this.value.itemDescription
        ? true
        : this.$refs.itemId.isValid();
      let unitIdValid = this.value.itemDescription
        ? this.$refs.unitId.isValid()
        : true;

      return formValid && itemIdValid && unitIdValid;

      //let itemSelectValidation = this.$refs.itemSelect.isValid();
      //let formValidation = this.$refs.form.validate();
      //return formValidation; //&& itemSelectValidation;
    },
    async getItem() {
      this.loadingItem = true;
      if (this.value.itemId) {
        let res = await this.$http.get(`item/s-id?id=${this.value.itemId}`);
        if (res.success) if (res.data) this.selectedItem = res.data;
      }
      this.loadingItem = false;
    },
    async getUnit() {
      this.loadingItem = true;
      if (this.value.unitId) {
        let res = await this.$http.get(`unit/s-id?id=${this.value.unitId}`);
        if (res.success) if (res.data) this.selectedUnit = res.data;
      }
      this.loadingItem = false;
    },
    async setItem() {
      if (!this.value.itemId) {
        this.selectedItem = null;
        this.$refs.form.resetValidation();
        return;
      }
      await this.getItem();
      this.$refs.form.resetValidation();
    },
    async getUnits() {
      let res = await this.$http.get("unit");
      if (res.success) this.units = res.data.data;
    },
    selectItem(value) {
      if (value) {
        this.value.itemId = value.id;
      }
      this.$emit("select", value);
      this.$emit("input", this.value);
    }
  },
  async mounted() {
    this.selectedItem = null;
    this.selectedUnit = null;
    await this.getUnits();
    await this.getUnit();
    await this.setItem();
  }
};
</script>